import getAdjReason from './getAdjReason'
import isEmpty from './isEmpty'

function appendUniqueReason(character, reasonKey, reasonText) {
  if (isEmpty(reasonText)) {
    return character
  }

  const existingReasons = isEmpty(character[reasonKey])
    ? []
    : character[reasonKey]
        .split('. ')
        .map((entry) => entry.trim())
        .filter((entry) => !isEmpty(entry))

  if (existingReasons.includes(reasonText)) {
    return character
  }

  if (existingReasons.length === 0) {
    character[reasonKey] = reasonText
  } else {
    character[reasonKey] += '. ' + reasonText
  }

  return character
}
//----------------------------------------------
// load specific characteristic adj top reasons
//----------------------------------------------
export default function loadSpecificCharacteristicAdjTopReasons({ adj, source, character } = {}) {
  console.log('--------------------------')
  console.log('IN loadSpecificCharacteristicAdjTopReasons')
  console.log('adj:', adj)
  console.log('source:', source)
  console.log('character:', character)
  /*

  adjs can come from:
  - characteristic (i.e. not from rune - adjs added directly to characteristic)
  - rune (i.e. from rune characteristic adjs)

  */
  //---------
  // defense
  //---------
  if (isEmpty(adj) || isEmpty(source) || isEmpty(character)) {
    console.error('loadSpecificCharacteristicAdjTopReasons: missing required parms')
    return character
  }
  //==========================================================================================
  // A. where characteristic adj (i.e. not from rune - adjs added directly to characteristic)
  //-----------------------------
  if (source === 'characteristic' || source === 'character_direct') {
    //-------------------
    // set reason for adj
    //--------------------
    if (!isEmpty(adj.adj_reason)) {
      let top_level_reason = getAdjReason(adj.adj_reason, adj.adj_value)
      character = appendUniqueReason(character, adj.name + '_adjs_reasons', top_level_reason)
    }
    //===============================================================================
    // B. where rune characteristic adj
    //----------------------------------
  } else if (source === 'integrated_rune') {
    //-------------------
    // set reason for adj
    //--------------------
    if (!isEmpty(adj.rune_name)) {
      //-------------------------
      // capitalise first letter
      //-------------------------
      let top_level_reason = getAdjReason(adj.rune_name, adj.adj_value)
      character = appendUniqueReason(character, adj.name + '_adjs_reasons', top_level_reason)
    }
    //===============================================================================
    // C. catch source error
    //-----------------------
  } else {
    console.error('loadSpecificCharacteristicAdjTopReasons: invalid source parm = ', source)
  }
  return character
}
